import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import Header1 from "../../Components/seperate Components/Header1";
import Blog2 from "../../Components/Blog2";
import {
  faChevronRight,
  faEnvelopeOpenText,
  faMapLocation,
  faPhone,
  faPhoneAlt,
} from "@fortawesome/free-solid-svg-icons";
import "../../Styles/Redirecting Styles/FooterStyle/Contact.css";
import Footer from "../../Components/Footer";
import Spinner from "../../Components/seperate Components/Spinner";
import swal from "sweetalert";
import { Helmet } from "react-helmet";
import Blog from "../../Components/Blog";
const ContactUs = () => {
  const containerStyle = {
    width: "400px",
    height: "400px",
  };

  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [message, setMessage] = useState("");
    const [secondName, setSecondName] = useState("");

  const [industry, setIndustry] = useState("");
  const [position, setPosition] = useState("");
  const [intrust, setIntrust] = useState("");
  const [messageTwo, setMessageTwo] = useState("");


  const [service, setService] = useState("");
  const [description, setDescription] = useState("");
  const [spinner, setSpinner] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSpinner(true);
    try {
      // https://mars.zithas.com/api/contactus
      // http://ztpl.net/ambrella-consulting/api/contactMail.php
      let res = await fetch("", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstName: firstName,
          email: email,
          mobile: mobile,
          secondName: secondName,

          industry: industry,
          position: position,
          intrust: intrust,
          messageTwo: messageTwo,

          service: service,
          description: description,
        }),
      });
      console.log(res);

      let resJson = await res.json();
      if (res.status === 200) {
        setFirstName("");
        setEmail("");
        setMobile("");
        setSecondName("");

        setIndustry("");
        setPosition("");
        setIntrust("");
        setMessageTwo("");

        setService("");
        setDescription("");
        setSpinner(false);
        swal({
          icon: "success",
          text: "Data has been send Sucessfully we will get in touch with you as soon as Possible",
        });
      } else {
        alert("Some error occured");
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Contact Ambrella consulting</title>
        <meta
          name="description"
          content="Ambrella is one of top web development companies, providing expert web solutions, including SMM and digital marketing services. Get in touch with us today."
        />
      </Helmet>

      <Header1 />

      {/* <div
        className="bd-page-title-area bd-page-title-bg_contact pt-120 pb-20"
       
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="bd-page-title text-center z-index">
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "38px", color: "#01536E" }}
                >
                  Contact Us
                </h2>
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#01536E" }}
                >
                  Let’s Build the Future Together
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Get in touch with us to discuss your strategic consulting
                      and technology needs. We will be happy to co-create a plan
                      to turn your ambitions into reality. We are constantly
                      looking at partnering with talented individuals and
                      startups in mutually beneficial collaborations.
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */} 
         <div
        className="bd-page-title-area bd-page-title-bg2 pt-120 pb-20"
        // style={{ height: "380px" }}
      >
        <div className="container buisnessHeader">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                
              >
                <h2
                  className="breadcrumb-title buisnessH2 "
                  style={{ fontSize: "38px", color: "#01536E" }}
                >
                  Contact Us
                </h2>
                {/* <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Business automation blends technology with strategy to
                      streamline operations and enhance efficiency.
                    </p>
                  </nav>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="bd-choose-area fix  pb-20 buisnessFirstText" style={{marginTop:"-20px"}}>
  <div className="container" style={{ maxWidth: "1270px" }}>
    <div className="bd-choose-shape">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="bd-choose-text z-index" style={{ textAlign: "center" }}>
            <div className="bd-section-title-wrapper mb-35">
              {/* Optionally you can add a title here if needed */}
            </div>
            <div>
                  <p style={{fontSize:"16px"}}>
              Are you interested in knowing more about Ambrella's Consulting
              or IT Application services?
            </p>
              <p style={{fontSize:"16px"}}>
              Are you interested in partnering with Ambrella to find new
              business and markets for your services or products?
            </p>
             <p style={{fontSize:"16px"}}>
              Fill out some info and we will be in touch shortly. We can't
              wait to hear from you!
            </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
      <div className="pt-10">
        <Blog2/>
      </div>

      {/* <section className="bd-contact-area pt-105 contactPhone">
        <div className="container">
          <div className="row ">
            <div className="col-xxl-4 col-xl-5 col-lg-5">
              <div className="bd-contact-wrapper pb-20">
                <div className="bd-contct-item gray-bg mb-30">
                  <div className="bd-contct-item-icon">
                    <i>
                      {" "}
                      <FontAwesomeIcon icon={faPhone} />
                    </i>
                  </div>
                  <div className="bd-contct-item-text">
                    <h5 className="bd-contct-item-text-title ">Phone</h5>
                    <ul style={{ listStyle: "none" }}>
                      <li
                        style={{
                          color: "var(--clr-theme-1)",
                          fontWeight: "550",
                        }}
                      >
                        General Inquiry
                      </li>
                    </ul>
                    <a href="tel:+6587852030" className="mbb-5 pb-20">
                      +65 87852030
                    </a>
                  </div>
                </div>
                <div className="bd-contct-item gray-bg mb-30">
                  <div className="bd-contct-item-icon">
                    <i>
                      {" "}
                      <FontAwesomeIcon icon={faEnvelopeOpenText} />
                    </i>
                  </div>
                  <div className="bd-contct-item-text">
                    <h5 className="bd-contct-item-text-title">Email</h5>
                    <a
                      href="mailto:info@ambrellaconsulting.com"
                      className="mbb-5"
                    >
                      info@ambrellaconsulting.com
                    </a>
                  </div>
                </div>
                <div
                  className="bd-contct-item gray-bg mb-30"
                  style={{ paddingRight: "20px" }}
                >
                  <div className="bd-contct-item-icon">
                    <i>
                      <FontAwesomeIcon icon={faMapLocation} />
                    </i>
                  </div>
                  <div className="bd-contct-item-text">
                    <h5 className="bd-contct-item-text-title">Location</h5>
                    <ul style={{ listStyle: "none" }}>
                      <li
                        style={{
                          color: "var(--clr-theme-1)",
                          fontWeight: "550",
                        }}
                      >
                        Zithas Technologies Pvt.Ltd.
                      </li>
                    </ul>
                    <span className="pb-20">
                      8 Boon Keng Road, Singapore 330008{" "}
                    </span>
                    <ul style={{ listStyle: "none" }}>
                                            <li style={{ color: "var(--clr-theme-1)", fontWeight: "550" }}>Zithas Technologies LTD (UK)</li>
                                            <span> Thornbury, Bristol, England, UK
                                            </span>
                                        </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-8 col-xl-7 col-lg-7">
              <div className="bd-contact-form-wrapper mb-50">
 
                <h2 className="bd-section-title mb-35">Get in Touch</h2>

<div className="mb-5"
//  style={{ textAlign: "center" }}
 >
  <span
    className="pb-20"
    style={{ color: "gray", fontSize: "19px", fontFamily: "sans-serif", wordSpacing: "2px" }}
  >
    Are you interested in knowing more about Ambrella's Consulting or IT Application services?
  </span>
  <br />
<span
  className="pb-20"
  style={{
    color: "gray",
    fontSize: "19px",
    fontFamily: "sans-serif",
    wordSpacing: "1px",
  }}
>
  Are you interested in partnering with Ambrella to find new business and markets for your services or products?
</span>
  <br />
  <span
    className="pb-20"
    style={{ color: "gray", fontSize: "19px", fontFamily: "sans-serif", wordSpacing: "2px" }}
  >
    Fill out some info and we will be in touch shortly. We can't wait to hear from you!
  </span>
</div>


                {spinner && <Spinner />}
                <form onSubmit={handleSubmit}>
                  <div className="row contact-reponsive">
                    <div className="col-md-6">
                      <div className="bd-contact-field mb-30">
                        <input
                          type="text"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          className="contact-form form-reponsive"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="bd-contact-field mb-30">
                        <input
                          type="text"
                          className="form-reponsive"
                          value={secondName}
                          onChange={(e) => setSecondName(e.target.value)}
                          placeholder="Last Name"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-6 email-form-responsive">
                      <div className="bd-contact-field mb-30">
                        <input
                          type="email"
                          value={email}
                          className="form-reponsive"
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Email"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-6 email-form-responsive">
                      <div className="bd-contact-field mb-30">
                        <input
                          type="text"
                          value={mobile}
                          onKeyPress={(event) => {
                            if (!/[0-9.]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          className="form-reponsive"
                          onChange={(e) => setMobile(e.target.value)}
                          placeholder="Phone No"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="bd-contact-field mb-30">
                        <input
                          type="text"
                          className="form-reponsive"
                          value={industry}
                          onChange={(e) => setIndustry(e.target.value)}
                          placeholder="Industry"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="bd-contact-field mb-30">
                        <input
                          type="text"
                          className="form-reponsive"
                          value={position}
                          onChange={(e) => setPosition(e.target.value)}
                          placeholder="Position"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="bd-contact-field mb-30">
                        <input
                          type="text"
                          className="form-reponsive"
                          value={position}
                          onChange={(e) => setPosition(e.target.value)}
                          placeholder="Country"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <select
                        className="form-select form-select-sm"
                        aria-label=".form-select-sm example"
                        style={{
                          width: "97%",
                          height: "60px",
                          backgroundColor: "var(--clr-bg-gray)",
                          border: "none",
                          borderRadius: "10px",
                          color: "var(--clr-body-text)",
                          fontWeight: "400",
                          fontSize: "16px",
                          paddingLeft: "20px",
                          marginLeft: "10px",
                          marginBottom: "30px",
                        }}
                        value={intrust}
                        onChange={(e) => setIntrust(e.target.value)}
                        required
                      >
                        <option
                          style={{
                            color: "var(--clr-body-text)",
                            fontSize: "16px",
                          }}
                        >
                          Select the Interest
                        </option>
                        <option value="Strategic Consulting">
                          Strategic Consulting
                        </option>
                        <option value="Technology Services">
                          Technology Services
                        </option>
                        <option value="Partnership">Partnership</option>
                        <option value="General Enquiry">General Enquiry</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <div className="bd-contact-field mb-30">
                        <textarea
                          placeholder="Share your Message"
                          value={messageTwo}
                          onChange={(e) => setMessageTwo(e.target.value)}
                          style={{ height: "220px", width: "100%" }}
                          required
                        ></textarea>
                      </div>
                    </div>

                    <h2
                      className="bd-section-title mt-20 mb-35"
                      style={{ fontSize: "34px" }}
                    >
                      Select the Sevice Which You Want
                    </h2>

                    <div className="bd-contact-field mb-30">
                      <select
                        className="form-select form-select-sm"
                        aria-label=".form-select-sm example"
                        style={{
                          width: "100%",
                          height: "60px",
                          backgroundColor: "var(--clr-bg-gray)",
                          border: "none",
                          borderRadius: "10px",
                          color: "var(--clr-body-text)",
                          fontWeight: "400",
                          fontSize: "16px",
                          paddingLeft: "20px",
                        }}
                        value={service}
                        onChange={(e) => setService(e.target.value)}
                        required
                      >
                        <option
                          style={{
                            color: "var(--clr-body-text)",
                            fontSize: "16px",
                          }}
                        >
                          Select the Services
                        </option>
                        <option value="Business Audit"> Business Audit </option>
                        <option value="Bespoke System">Bespoke System</option>
                        <option value="Business Automation">
                          Business Automation
                        </option>
                        <option value="Software Development">
                          Software Development
                        </option>
                        <option value="Mobile Apps Development">
                          Mobile Apps Development
                        </option>
                        <option value="Hire a Resource">Hire a Resource</option>
                        <option value="Digital Marketing">
                          Digital Marketing
                        </option>
                        <option value="Hosting Services">
                          Hosting Services
                        </option>
                        <option value="MICRO Services">MICRO Services</option>
                        <option value="Maintenance Packages">
                          Maintenance Packages
                        </option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <div className="bd-contact-field mb-30">
                        <textarea
                          placeholder="Share your Requirement for Service Selected"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          style={{ height: "220px", width: "100%" }}
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="bd-contact-field">
                        <button type="submit" className="theme-btn">
                          Submit Enquiry
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <div>
        <div className="loading-spinner" disabled ={isLoading} >

        </div>
       </div> */}

      {/* <div className="bd-map-area pt-100 pb-140">
            <div className="container">
                <div className="bd-map">
                <iframe src="https://www.google.com/maps/d/embed?mid=1lUhd5Xk9U0Ko_RF-3BvncOggYsxgyxw&ehbc=2E312F&z=2" width="640" height="480" frameBorder="0" style={{border:"0px"}} ></iframe>
                </div>
            </div>
        </div> */}

      <Footer />
    </div>
  );
};

export default ContactUs;
